<template>
<div class="page">
    <panel ref="panel" :wapTitle="name" :appLink="appLink" :spreadID="'0'" :showNav="true" :isShowNav="false" :isDetail="true" @gotoApp="gotoApp" :isApp="false"></panel>
    <div class="auctionInfos">
        <template v-for="(item, index) in detailExtraInfo">
            <dl v-if="item.type == 'session'" :key="index" @click="jumpSession('/session/' + item.sessionCode + waterLink,'2')">

                <dt>{{ item.label }}</dt>
                <dd>
                    {{ item.text }}
                    <span class="icon detailIcon"></span>
                </dd>
            </dl>
            <dl v-else-if="item.type == 'company'" @click="jumpSession('/organ/' +
                                item.sessionCode +
                                waterLink,'1')" :key="index">

                <dt>{{ item.label }}</dt>
                <dd>
                    {{ item.text }}
                    <span class="icon"></span>
                    <span v-if="item.type == 'company'" class="icon detailIcon"></span>
                </dd>

            </dl>
            <dl v-else-if="item.type == 'map'" :key="index" >
                <a href="javascipt:;" :data-url="appLink" class="gotoAppBtn" @click="gotoApp">
                    <dt>{{ item.label }}</dt>
                    <dd>
                        {{ item.text }}
                        <span class="icon"></span>
                        <span class="icon addressIcon"></span>
                    </dd>
                </a>
            </dl>
            <dl v-else-if="item.type == 'topart20'" :key="index">
                <a data-url="appLink" class="gotoAppBtn" @click="gotoApp">
                    <dt>{{ item.label }}</dt>
                    <dd>
                        &nbsp;
                        <span class="icon"></span>
                        <span v-if="item.type == 'topart20'" class="icon detailIcon"></span>
                    </dd>
                </a>
            </dl>
            <dl v-else-if="item.type == 'fastNews'" :key="index" @click="gotoApp">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.text }}</dd>
            </dl>
            <dl v-else-if="item.type == 'culturalLicense'" :key="index" @click="seeImg(item.pic)">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.text }}
                    <template v-if="item.pic">
                        <span class="icon"></span>
                        <span class="icon detailIcon"></span>
                    </template>

                </dd>
            </dl>
            <dl v-else :key="index">
                <dt>{{ item.label }}</dt>
                <dd>{{ item.text }}</dd>
            </dl>
        </template>
    </div>
    <div class="rules" @click="openPop" v-if="msg">
        拍卖规则<span class="detailIcon"></span>
    </div>
    <div class="priceInfo" style="display: block" v-if="daiPaiExtraInfo">
        <dl v-for="(k, b) in daiPaiExtraInfo" :key="b">
            <dt>{{ k.label }}</dt>
            <dd>{{ k.text }}</dd>
        </dl>
        <!-- <dl>
                <dt>保证金</dt>
                <dd>1:3</dd>
            </dl>
            <dl>
                <dt>原始币种</dt>
                <dd>rmb</dd>
            </dl> -->
    </div>
    <div class="speSwiper" v-if="aboutSpecial.length != 0">
        <div class="swiper-container">
            <ul class="swiper-wrapper">
                <li class="swiper-slide" v-for="(item, index) in aboutSpecial" @click="jumpSpecial('/special/'+item.specialCode,i)" :key="index">
                  
                        <div class="imgCenter">
                            <!-- <img src="../../assets/img/avator.jpeg" alt="" />coverPic -->
                            <img :src="item.coverPic" alt="" />
                            <span class="HiPic"></span>
                            <template v-if="item && item.live_info">
                                <span class="live" v-if="item.live_info.live_status == 2"></span>
                                <span class="liveStatus liveReview" v-else-if="item.live_info.have_live == 1 && item.live_info.live_status == 0 || item.live_info.live_status == 1">即将开播</span>
                                <span class="liveReview" v-else-if="item.live_info.live_status == 4 && item.live_info.have_review == 1">直播回放</span>
                            </template>
                        </div>
                        <h3 class="name">{{ item.name }}</h3>
                        <div class="tags">
                            <template v-for="(tags,k) in item.live_info.label_list">
                                <span v-if="tags.name == '视频直播'" class="tag videoLive" :key="k"></span>
                                <span v-if="tags.name == '同步拍'" class="tag tbPai" :key="k"></span>
                                <span v-if="tags.name == '限时拍'" class="tag xsPai" :key="k">限时拍</span>
                            </template>
                        </div>
                
                </li>
            </ul>
        </div>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import Swiper from "swiper";

import {
    mapActions,
    mapGetters
} from "vuex";
import {
    getWXConfig
} from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from "@/components/common/downloadApp";
import {
    audience
} from "@/api/auction";
import watermark from "@/components/common/watermark";
import {
    scMdFunc,
} from "@/assets/js/scData";

export default {
    name: "sessionDetail",
    data() {
        return {
            showWater: false,
            waterLink: "",
            param: {
                specialCode: "",
                only_meta: 1,
            },
            showPop: false,
            msg: "",
            keyWorlds: {
                specialCode: "",
            },
            detailExtraInfo: [],
            aboutSpecial: [],
            name: "",
            appLink: "/2/4/" + this.$route.query.specialCode,
            daiPaiExtraInfo: [],
        };
    },
    created() {

    },
    asyncData({
        store,
        route
    }) {
        // console.log(route);
        // console.log(store, 33333);
        let dataJSON = {
            specialCode: route.query.specialCode,
            only_meta: 1,
        };
        return store.dispatch("pageSpecialDetail/getAudienceDetail", [
            dataJSON,
            () => {},
        ]);
    },
    components: {
        panel,
        DownLoadApp,
        watermark,
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageSpecialDetail/getIsLoadIng",
            getData: "pageSpecialDetail/getData",
        }),
    },
    methods: {
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
        },
        jumpSession(e, i) {
            scMdFunc('allClick', {
                cur_page: '34',
                cur_moudle: '34-1',
                cur_button: '34-1-' + i,
            })
            window.location.href = e
        },
        jumpSpecial(e, i) {
            scMdFunc('allClick', {
                cur_page: '34',
                cur_moudle: '34-2',
                cur_button: '34-2-'+ (Number(i) + 1),
            })
            window.location.href = e
        },
        seeImg(e) {
            if (e.length>0) {
                this.$router.push({
                    path: '/culturalLicense?specialCode='+this.$route.query.specialCode
                })
            }
    
            // if (e) {
            //     ImagePreview({
            //         images: [e],
            //         showIndex: false
            //     })
            // }

        },
        goBack() {
            if (window.history.state) {
                this.$router.back();
            } else {
                this.$router.push({
                    path: '/'
                })
            }
        },
        openPop() {
            this.$router.push({
                name: 'specialExplain',
                query: {
                    specialCode: this.$route.query.specialCode,
                    from: this.$route.query.from
                }
            });
        },
        closePop() {
            this.showPop = false;
        },
        ...mapActions({
            getAudienceDetail: "pageSpecialDetail/getAudienceDetail",
        }),
        filteData() {
            // console.log("this.$state", this.$store.state["pageSpecialDetail"]);
            // this.detailExtraInfo =
            //     this.$store.state["pageSpecialDetail"]["data"].detailExtraInfo;
            // this.aboutSpecial =
            //     this.$store.state["pageSpecialDetail"]["data"].aboutSpecial;

            // this.name = this.$store.state["pageSpecialDetail"]["data"].name;

            // 微信分享+title
            let dome = this.$store.state["pageSpecialDetail"]["data"];
            document.title = dome.meta ? dome.meta.title : "";
            let head = document.getElementsByTagName("head");
            if (!document.querySelector("meta[name=description]")) {
                let meta = document.createElement("meta");
                meta.name = "description";
                meta.content = dome.meta ? dome.meta.description : "";
                head[0].appendChild(meta);
            } else {
                document
                    .querySelector("meta[name=description]")
                    .setAttribute(
                        "content",
                        dome.meta ? dome.meta.description : ""
                    );
            }
            window.AFedWxShareData = {
                title: dome.meta ? dome.meta.shareTitle : "",
                imgUrl: dome.meta.pic ||
                    "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
                desc: dome.meta.description || "",
                link: window.location.href,
            };
            getWXConfig(window.AFedWxShareData);
        },

        // 接口
        getAudienceDetailList() {
            this.keyWorlds = {
                specialCode: this.$route.query.specialCode,
                orderby: 1
            };
            audience(this.keyWorlds).then((res) => {
                if (res.code == 0) {
                    console.log(res.data.company);
                    this.detailExtraInfo = res.data.detailExtraInfo;
                    this.aboutSpecial = res.data.aboutSpecial;
                    this.name = res.data.name;
                    this.msg = res.data.rule;
                    // 拍卖佣金+原始币种+货币比例
                    this.daiPaiExtraInfo = res.data.daiPaiExtraInfo;
                    setTimeout(function () {
                        new Swiper('.swiper-container', {
                            slidesPerView: 'auto',
                            loop: false
                        });
                    }, 500)
                }
            });
        },
    },
    mounted() {
        if (
            (this.$route.query.from && this.$route.query.from == 1) ||
            this.$route.query.from == 2
        ) {
            this.showWater = true;
            this.waterLink = "&from=" + this.$route.query.from;
        }
        if (!this.getIsLoadIng) {
            console.log("前端调用");
            this.param.specialCode = this.$route.query.specialCode;
            this.getAudienceDetail([
                this.param,
                () => {
                    this.filteData();
                },
            ]);
        } else {
            console.log("服务端调用", this.param);
            this.filteData();
        }
        this.getAudienceDetailList();
    },
};
</script>

<style scoped>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/swiper.css");

.header {
    height: 2.2rem;
    background: #ffffff;
}

.greenHeader {
    background: #35bd7d;
}

.header h3 {
    margin-left: 2.2rem;
    margin-right: 2.2rem;
    text-align: center;
    font-size: 0.9rem;
    line-height: 2.2rem;
    color: #27282d;
}

.header .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_light@2x.png) no-repeat;
    background-size: cover;
}

.greenHeader .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_white@2x.png) no-repeat;
    background-size: cover;
}

.page {
    width: 18.75rem;
    margin: 0 auto;
}

.auctionInfos {
    padding: 0 0.75rem;
    background: #ffffff;
}

.auctionInfos dl {
    padding: 0.65rem 0 0.7rem;
    font-size: 0.75rem;
    border-bottom: 0.05rem solid #dddee3;
    line-height: 1.05rem;
    overflow: hidden;
}

.auctionInfos dl:last-child {
    border-bottom: 0;
}

.auctionInfos dt {
    width: 3.75rem;
    float: left;
    color: #999;
    white-space: nowrap;
}

.auctionInfos dd {
    margin-left: 3.75rem;
    padding-right: 0.8rem;
    position: relative;
}

.auctionInfos dd .icon {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    top: 50%;
    right: 0;
    margin-top: -0.4rem;
    background-repeat: no-repeat;
    background-size: cover;
}

.auctionInfos dd .detailIcon {
    background-image: url(../../assets/img/icon_detial_arrow.png);
}

.auctionInfos dd .addressIcon {
    background-image: url(../../assets/img/icon_address.png);
}

.rules {
    margin-top: 0.25rem;
    height: 2.6rem;
    background: #ffffff;
    padding: 0 0.75rem;
    font-size: 0.8rem;
    line-height: 2.6rem;
    color: #27282d;
    position: relative;
}

.rules .detailIcon {
    position: absolute;
    width: 0.8rem;
    height: 0.8rem;
    right: 0.75rem;
    top: 0.8rem;
    background: url(../../assets/img/icon_detial_arrow.png) no-repeat;
    background-size: cover;
}

.tips {
    padding: 0 0.75rem;
    margin-top: 0.25rem;
    font-size: 0.6rem;
    color: #dd2815;
    line-height: 0.85rem;
}

.priceInfo {
    padding: 0 0.75rem;
    background: #ffffff;
    margin-top: 0.25rem;
}

.priceInfo dl {
    padding: 0.65rem 0 0.7rem;
    font-size: 0.75rem;
    line-height: 1.05rem;
    border-bottom: 0.05rem solid #dddee3;
}

.priceInfo dl:last-child {
    border-bottom: 0;
}

.priceInfo dt {
    width: 3.75rem;
    float: left;
}

.priceInfo dd {
    margin-left: 3.75rem;
    padding-right: 0.8rem;
    position: relative;
    color: #dd2815;
}

.speSwiper {
    margin-top: 0.25rem;
    background: #ffffff;
    padding: 0.75rem;
}

.speSwiper .swiper-slide {
    width: 4.75rem;
    margin-right: 0.4rem;
}

.speSwiper .swiper-slide .imgCenter {
    height: 6.25rem;
    background: #d8d8d8;
    border-radius: 0.2rem;
    overflow: hidden;
    position: relative;
}

.speSwiper .swiper-slide .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.speSwiper .swiper-slide .imgCenter .live {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    height: 1rem;
    background: #18bd6f url(../../assets/img/live.gif) no-repeat center;
    background-size: contain;
    font-size: 0.55rem;
    line-height: 1rem;
    color: #ffffff;
}

.speSwiper .swiper-slide .imgCenter .liveReview {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.1rem;
    background: rgba(0, 0, 0, 0.85);
    font-size: 0.65rem;
    line-height: 1.1rem;
    color: #ffffff;
    text-align: center;
}

.speSwiper .swiper-slide .imgCenter .HiPic {
    background: url(../../assets/img/icon_list_HDpic_26@2x.png) no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    width: 1.7rem;
    height: 0.8rem;
    background-size: 100% 100%;
}

.speSwiper .swiper-slide .name {
    margin-top: 0.4rem;
    font-size: 0.65rem;
    line-height: 0.9rem;
    color: #969696;
    height: 1.8rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}

.speSwiper .swiper-slide .tags {
    margin-top: 0.3rem;
    font-size: 0;
    display: flex;
    justify-content: space-between;
}

.speSwiper .swiper-slide .tag {
    display: inline-block;
    height: 0.8rem;
    background-repeat: no-repeat;
    background-size: contain;
}

.speSwiper .swiper-slide .tag:last-child {
    margin-right: 0;
}

.speSwiper .swiper-slide .videoLive {
    width: 2.4rem;
    background-image: url(../../assets/img/icon_video_live.png);
}

.speSwiper .swiper-slide .imgLive {
    width: 2.4rem;
    background-image: url(../../assets/img/icon_img_live.png);
}

.speSwiper .swiper-slide .tbPai {
    width: 1.9rem;
    background-image: url(../../assets/img/icon_tbpai.png);
}

.speSwiper .swiper-slide .xsPai {
    border: 1px solid #eee;
    color: #999;
    font-size: 0.45rem;
    padding: 0.03rem 0.1rem;
    height: auto;

}

article {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(100%);
    z-index: -1;
    background-color: #fff;
    transition: 0.2s transform ease-in-out;
}

article.openExplain {
    transform: translateX(0);
    z-index: 100;
}

.header {
    height: 2.2rem;
    background: #ffffff;
    margin-top: 6rem;
}

.header h3 {
    margin-left: 2.2rem;
    margin-right: 2.2rem;
    text-align: center;
    font-size: 0.9rem;
    line-height: 2.2rem;
    color: #27282d;
}

.header .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_light@2x.png) no-repeat;
    background-size: cover;
}

.explain {
    padding: 1.5rem 0.75rem 3.75rem;
    background-color: #fff;
}

.explain h1 {
    line-height: 3rem;
    font-size: 1rem;
    text-align: center;
}

.explain h2 {
    font-size: 0.65rem;
    color: #323232;
    padding: 1rem 0rem 0.25rem;
}

.explain li {
    line-height: 0.9rem;
    font-size: 0.6rem;
    color: #646464;
}

.explain p {
    margin-bottom: 0.25rem;
    font-size: 0.6rem;
    color: #646464;
}

.explain img {
    max-width: 100%;
}
</style>
